import React, { Component } from "react";
import Axios from "../../../auth/axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchVendorInformation } from "../../Services/allServices";
import { FormGroup, Label, Input, Row, Col, Button } from "reactstrap";
class BusinessInformation extends Component {
  state = {
    //tax details
    typeOfBusiness: "",
    gstStatus: "",
    tanStatus: "",
    tanNumber: "",
    stateOfSupply: "",
    taxCode: "",

    //Details of Business
    legalNameOfBusiness: "",
    businessPanNumber: "",
    registeredAddressFirm: "",
    imageGallery: "",

    //GSTIN Details
    gstRegistrationType: "",
    gstinNumber: "",
    gstinDocs: "",

    //Bank Account Details
    bankAccountType: "",
    accountHolderName: "",
    accountNumber: "",
    ifscCode: "",
    bankAddress: "",

    //for doc names
    cancelledChequeDocs: "",
    isChequeAvailable: "",
    imageGalleryNames: [],
    isImageGalleryAvailable: [],
    gstInDocsNames: [],
    isGstInDocAvailable: [],
    isLoading: false,
  };

  // for form text fields
  changeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // submit business information
  businessInformationDetails = async (event) => {
    event.persist();
    const {
      typeOfBusiness,
      gstStatus,
      tanStatus,
      tanNumber,
      stateOfSupply,
      taxCode,
      legalNameOfBusiness,
      businessPanNumber,
      registeredAddressFirm,
      gstRegistrationType,
      imageGalleryNames,
      gstinNumber,
      gstinDocs,
      bankAccountType,
      accountHolderName,
      accountNumber,
      ifscCode,
      bankAddress,
      cancelledChequeDocs,
      isLoading,
    } = this.state;
    const businessData = new FormData();
    // tax Details
    businessData.append("typeofBusiness", typeOfBusiness);
    businessData.append("gstStatus", gstStatus);
    businessData.append("tanStatus", tanStatus);
    businessData.append("tanNumber", tanNumber);
    businessData.append("stateOfSupply", stateOfSupply);
    businessData.append("taxCode", taxCode);

    // Business Details
    businessData.append("legalNameOfBusiness", legalNameOfBusiness);
    businessData.append("businessPanNumber", businessPanNumber);
    businessData.append("registeredAddressFirm", registeredAddressFirm);
    for (var y = 0; y < imageGalleryNames.length; y++) {
      businessData.append("imageGallery", imageGalleryNames[y]);
    }

    // GSTIN Details
    if (gstStatus == "1") {
      businessData.append("gstRegistrationType", gstRegistrationType);
      businessData.append("gstinNumber", gstinNumber);
      for (var x = 0; x < gstinDocs.length; x++) {
        businessData.append("gstinDocs", gstinDocs[x]);
      }
    }

    // Bank Account Details
    businessData.append("bankAccountType", bankAccountType);
    businessData.append("accountHolderName", accountHolderName);
    businessData.append("accountNumber", accountNumber);
    businessData.append("ifscCode", ifscCode);
    businessData.append("bankAddress", bankAddress);
    businessData.append("cancelledChequeDocs", cancelledChequeDocs);

    this.setState({ isLoading: true });
    Axios.post("/vendor/vendor-business", businessData)
      .then((response) => {
        console.log("Response => => ", response);
        this.setState({ isLoading: false });
        if (response.data.error) {
          toast.error(
            "Error Occurred while Submitted Business Information! Please Try Again!",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        } else {
          toast.success(`Business Information Submitted Successfully! `, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          this.props.onChangeBusinessStatusHandler();
        }
      })
      .catch((error) => {
        toast.error(
          "Error Occurred while Submitted Business Information! Please Try Again!",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      });
    event.preventDefault();
  };

  checkMimeTypeForDocuments = (event) => {
    let files = event.target.files;
    let count = 0;
    // console.log(files);
    for (let i = 0; i < files.length; i++) {
      console.log(i, " => ", files[i].type);
      if (
        files[i].type === "image/png" ||
        files[i].type === "image/jpeg" ||
        files[i].type === "image/jpg" ||
        files[i].type === "image/mpeg"
      ) {
        count++;
      } else {
        return false;
      }
    }

    if (count > 0) {
      return true;
    } else {
      return false;
    }
  };

  checkMimeTypeForGstDocs = (event) => {
    let files = event.target.files;
    let count = 0;
    // console.log(files);
    for (let i = 0; i < files.length; i++) {
      if (
        files[i].type === "image/png" ||
        files[i].type === "image/jpeg" ||
        files[i].type === "image/jpg" ||
        files[i].type === "image/mpeg" ||
        files[i].type === "application/pdf"
      ) {
        count++;
      } else {
        return false;
      }
    }

    if (count > 0) {
      return true;
    } else {
      return false;
    }
  };

  // Storing imageGalleryPic
  imageGalleryPic = (evnt) => {
    // console.log('calling image Gallery ')

    let allImages = evnt.target.files;
    if (allImages.length >= 5) {
      evnt.target.value = null;
      toast.error(`You can't upload more than 5 images`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }

    if (this.checkMimeTypeForDocuments(evnt)) {
      let imageGallery = [];
      for (var imgLen = 0; imgLen < allImages.length; imgLen++) {
        let images = allImages[imgLen];
        this.state.imageGalleryNames.push(images);
        imageGallery.push(images.name);
      }
      this.setState({ isImageGalleryAvailable: imageGallery });
      toast.success("Image Gallery Pictures are Uploaded Successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return true;
    } else {
      toast.error("Only png/jpeg/jpg/mpeg formats are Allowed!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }
  };

  // cancelledChequePic
  cancelledCheque = (vnt) => {
    // console.log('calling Handling Cancelled cheque')
    if (this.checkMimeTypeForDocuments(vnt)) {
      this.setState({
        cancelledChequeDocs: vnt.target.files[0],
        isChequeAvailable: vnt.target.files[0].name,
      });
      toast.success("Cheque Image Uploaded Successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error("Only png/jpeg/jpg/mpeg formats are Allowed!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }
  };

  // GST DocsHandler
  gstDocs = (event) => {
    // console.log('calling GST Docs')
    if (this.checkMimeTypeForGstDocs(event)) {
      const { isGstInDocAvailable } = this.state;
      isGstInDocAvailable.push(event.target.files[0].name);
      this.setState({
        gstinDocs: event.target.files,
        isGstInDocAvailable: isGstInDocAvailable,
      });
      toast.success("GST Document Uploaded Successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return true;
    } else {
      toast.error("Only png/jpeg/jpg/mpeg/pdf formats are Allowed!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }
  };

  componentDidMount = async () => {
    // this.setState({ isLoading: true });
    const vendorInformation = await fetchVendorInformation();
    // this.setState({ isLoading: false });
    // console.log('businessInformation Data => =>', vendorInformation.data.businessDetails);
    this.setState({
      typeOfBusiness: vendorInformation.data.businessDetails.typeofBusiness,
      gstStatus: vendorInformation.data.businessDetails.gstStatus,
      tanStatus: vendorInformation.data.businessDetails.tanTdsStatus,
      tanNumber: vendorInformation.data.businessDetails.tanNumber != 'undefined' ? vendorInformation.data.businessDetails.tanNumber : "",
      stateOfSupply: vendorInformation.data.businessDetails.stateOfSupply,
      taxCode: vendorInformation.data.businessDetails.taxCode,
      legalNameOfBusiness:
        vendorInformation.data.businessDetails.legalNameOfBusiness != 'undefined' ? vendorInformation.data.businessDetails.legalNameOfBusiness : "",
      businessPanNumber:
        vendorInformation.data.businessDetails.businessPanNumber != 'undefined' ? vendorInformation.data.businessDetails.businessPanNumber : "",
      registeredAddressFirm:
        vendorInformation.data.businessDetails.registeredAddress != 'undefined' ? vendorInformation.data.businessDetails.registeredAddress : "",
      gstRegistrationType:
        vendorInformation.data.businessDetails.gstRegistrationType,
      gstinNumber: vendorInformation.data.businessDetails.gstinNumber,
      bankAccountType: vendorInformation.data.businessDetails.bankAccountType,
      accountHolderName:
        vendorInformation.data.businessDetails.AccountHolderName,
      ifscCode: vendorInformation.data.businessDetails.ifscCode,
      bankAddress: vendorInformation.data.businessDetails.bankAddress,
      accountNumber: vendorInformation.data.businessDetails.accountNumber,
      isChequeAvailable:
        vendorInformation.data.businessDetails.cancelledChequeFile !== undefined
          ? vendorInformation.data.businessDetails.cancelledChequeFile
          : "",
      isGstInDocAvailable:
        vendorInformation.data.businessDetails.gstinDocsNames !== undefined
          ? vendorInformation.data.businessDetails.gstinDocsNames
          : [],
      isImageGalleryAvailable:
        vendorInformation.data.businessDetails.imageGalleryFilesPaths !==
          undefined
          ? vendorInformation.data.businessDetails.imageGalleryFilesPaths
          : [],
    });
  };

  render() {
    const {
      typeOfBusiness,
      tanStatus,
      tanNumber,
      stateOfSupply,
      taxCode,
      legalNameOfBusiness,
      businessPanNumber,
      registeredAddressFirm,
      bankAccountType,
      accountHolderName,
      accountNumber,
      ifscCode,
      bankAddress,
      gstRegistrationType,
      gstinNumber,
      isLoading,
      gstStatus,
      imageGalleryNames,
      gstInDocsNames,
      cancelledChequeDocs,
      isImageGalleryAvailable,
      isChequeAvailable,
      isGstInDocAvailable,
    } = this.state;
    return (
      <form
        className="vendorForm mt-2 business-details"
        onSubmit={(e) => this.businessInformationDetails(e)}
      >
        <div className="row">
          <div onClick={() => this.props.changeHandler("1")}>
            <span style={{ color: "#174C8B", fontSize: "13px" }}>
              <i className="bi bi-arrow-left-short ml-2" />
            </span>
            <span
              className="ml-1"
              style={{
                color: "#174C8B",
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              Back
            </span>
          </div>
          <div className="12">
            <div className="bussMainDiv">
              <span className="taxFont">Tax Details</span>
              <div className="mt-2">
                <select
                  className="form-select bussStyle"
                  id="typeOfBusiness"
                  name="typeOfBusiness"
                  onChange={(e) => this.changeHandler(e)}
                  value={typeOfBusiness}
                  required
                >
                  <option value="" selected>
                    Select Type of Business
                  </option>
                  <option value="1">Individual &amp; Freelancer</option>
                  <option value="2">Proprieteriship</option>
                  <option value="3">Partnership</option>
                  <option value="4">Trust/Society</option>
                  <option value="5">Private Ltd</option>
                </select>
              </div>

              <div className="mt-2">
                <select
                  className="form-select bussStyle"
                  id="gstStatus"
                  name="gstStatus"
                  onChange={(e) => this.changeHandler(e)}
                  value={gstStatus}
                  required
                >
                  <option value="" selected>
                    Select GST Status
                  </option>
                  <option value="0">I sell in GST Exempted Category</option>
                  <option value="1">I have GST Number</option>
                  <option value="2">I have never registered for GST</option>
                </select>
              </div>

              <div className="mt-2">
                <select
                  className="form-select bussStyle"
                  id="tanStatus"
                  name="tanStatus"
                  onChange={(e) => this.changeHandler(e)}
                  required
                  value={tanStatus}
                >
                  <option value="" selected>
                    Select TDS-TAN Status
                  </option>
                  <option value="0">I am not liable to deduct TDS</option>
                  <option value="1">I have TAN for TDS</option>
                </select>
              </div>

              {this.state.tanStatus == "1" && (
                <div className="mt-2">
                  <input
                    type="text"
                    name="tanNumber"
                    id="tanNumber"
                    className="form-control rounded bussStyle"
                    placeholder="Enter TAN Number"
                    pattern="[A-Za-z]{4}[0-9]{5}[A-Za-z]"
                    onChange={(e) => this.changeHandler(e)}
                    style={{
                      padding: "11px",
                      background: "#F1F5FF",
                      color: "black",
                      fontSize: "12px",
                    }}
                    value={tanNumber}
                    required
                  />
                </div>
              )}

              <div className="mt-2 mb-4">
                <select
                  className="form-select bussStyle"
                  name="stateOfSupply"
                  onChange={(e) => this.changeHandler(e)}
                  required
                  id="stateOfSupply"
                  value={stateOfSupply}
                >
                  <option value="" selected>
                    Select state of supply
                  </option>
                  <option value="1">Andhra Pradesh</option>
                  <option value="2">Andaman and Nicobar Islands</option>
                  <option value="3">Arunachal Pradesh</option>
                  <option value="4">Assam</option>
                  <option value="5">Bihar</option>
                  <option value="6">Chandigarh</option>
                  <option value="7">Chhattisgarh</option>
                  <option value="8">Dadar and Nagar Haveli</option>
                  <option value="9">Daman and Diu</option>
                  <option value="10">Delhi</option>
                  <option value="11">Lakshadweep</option>
                  <option value="12">Puducherry</option>
                  <option value="13">Goa</option>
                  <option value="14">Gujarat</option>
                  <option value="15">Haryana</option>
                  <option value="16">Himachal Pradesh</option>
                  <option value="17">Jammu and Kashmir</option>
                  <option value="18">Jharkhand</option>
                  <option value="19">Karnataka</option>
                  <option value="20">Kerala</option>
                  <option value="21">Madhya Pradesh</option>
                  <option value="22">Maharashtra</option>
                  <option value="23">Manipur</option>
                  <option value="24">Meghalaya</option>
                  <option value="25">Mizoram</option>
                  <option value="26">Nagaland</option>
                  <option value="27">Odisha</option>
                  <option value="28">Punjab</option>
                  <option value="29">Rajasthan</option>
                  <option value="30">Sikkim</option>
                  <option value="31">Tamil Nadu</option>
                  <option value="32">Telangana</option>
                  <option value="33">Tripura</option>
                  <option value="34">Uttar Pradesh</option>
                  <option value="35">Uttarakhand</option>
                  <option value="36">West Bengal</option>
                </select>
              </div>

              {/* Business Start Here */}
              {this.state.typeOfBusiness !== "1" &&
                this.state.typeOfBusiness !== 1 && (
                  <>
                    <span className="taxFont">Business Details</span>
                    <div className="mt-2">
                      <input
                        type="text"
                        className="form-control bussStyle pl-2 rounded"
                        id="legalNameOfBusiness"
                        name="legalNameOfBusiness"
                        onChange={(e) => this.changeHandler(e)}
                        value={legalNameOfBusiness}
                        placeholder="Legal Name of Business/Firm"
                        required
                      />
                    </div>
                    <div className="mt-2">
                      <input
                        type="text"
                        className="form-control bussStyle pl-2 rounded"
                        id="businessPanNumber"
                        name="businessPanNumber"
                        pattern="[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"
                        onChange={(e) => this.changeHandler(e)}
                        value={businessPanNumber}
                        placeholder="Business PAN Number"
                        required
                      />
                    </div>
                    <div className="mt-2">
                      <textarea
                        name="registeredAddressFirm"
                        rows="3"
                        placeholder="Registered Address of Firm/Business"
                        required
                        minLength="10"
                        maxLength="110"
                        id="registeredAddressFirm"
                        className=" form-control bussStyle pl-2 rounded"
                        onChange={(e) => this.changeHandler(e)}
                        value={registeredAddressFirm}
                      ></textarea>
                    </div>
                    <div className="mt-2 mb-4">
                      <label class="qualification-label">
                        <input
                          type="file"
                          id="imageGallery"
                          multiple
                          name="imageGallery"
                          onChange={(e) => this.imageGalleryPic(e)}
                          required={
                            isImageGalleryAvailable.length > 0 ? false : true
                          }
                        />
                        <small class="name1">
                          <i className="bi bi-download downloadIcon"></i>Choose
                          file
                        </small>
                      </label>
                      {isImageGalleryAvailable.length > 0 ? (
                        isImageGalleryAvailable.map((data) => (
                          <span className="file_message">
                            {" "}
                            {data.split("/")[data.split("/").length - 1]}
                          </span>
                        ))
                      ) : (
                        <span className="file_message">Upload PAN</span>
                      )}
                      {/* <input
                      type="file"
                      className="form-control"
                      id="imageGallery"
                      name="imageGallery"
                      onChange={this.imageGalleryPic}
                      multiple
                      required={
                        isImageGalleryAvailable.length > 0 ? false : true
                      }
                    />
                    {isImageGalleryAvailable.length > 0
                      ? isImageGalleryAvailable.map((data) => (
                          <span>
                            {" "}
                            {data.split("/")[data.split("/").length - 1]}
                          </span>
                        ))
                      : ""} */}
                    </div>
                  </>
                )}

              {/* GSTIN Details */}
              {this.state.gstStatus == "1" ? (
                <>
                  <span className="taxFont">GSTIN Details</span>
                  <div className="mt-1">
                    <select
                      className="form-select bussStyle"
                      id="gstRegistrationType"
                      name="gstRegistrationType"
                      onChange={(e) => this.changeHandler(e)}
                      value={gstRegistrationType}
                      required
                    >
                      <option value="" selected>
                        Select
                      </option>
                      <option value="1">Regular</option>
                      <option value="2">Composition</option>
                    </select>
                  </div>
                  <div className="mt-2">
                    <input
                      type="text"
                      className="form-control bussStyle rounded"
                      name="gstinNumber"
                      id="gstinNumber"
                      value={gstinNumber}
                      placeholder="GST Number"
                      onChange={(e) => this.changeHandler(e)}
                      pattern="\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}"
                      required
                      style={{ padding: "12px" }}
                    />
                  </div>
                  <div className="mt-2 mb-5">
                    <label class="qualification-label">
                      <input
                        type="file"
                        id="file-input"
                        multiple
                        name="gstinDocs"
                        onChange={this.gstDocs}
                        required={isGstInDocAvailable.length > 0 ? false : true}
                      />
                      <small class="name1">
                        <i className="bi bi-download downloadIcon"></i>Choose
                        file
                      </small>
                    </label>
                    {isGstInDocAvailable.length > 0 ? (
                      isGstInDocAvailable.map((data) => (
                        <span className="file_message">
                          {data.split("/")[data.split("/").length - 1]}
                        </span>
                      ))
                    ) : (
                      <span className="file_message">Upload GST</span>
                    )}
                  </div>
                </>
              ) : null}

              {/* Bank Account Details */}

              <span className="taxFont">Bank Account Details</span>
              <div className="mt-2">
                <select
                  className="form-select bussStyle"
                  id="bankAccountType"
                  name="bankAccountType"
                  onChange={(e) => this.changeHandler(e)}
                  value={bankAccountType}
                  required
                >
                  <option value="" selected>
                    Select Bank A/C Type
                  </option>
                  <option value="1">Saving A/C</option>
                  <option value="2">Current A/C</option>
                </select>
              </div>
              <div className="mt-2">
                <input
                  type="text"
                  className="form-control bussStyle1 rounded"
                  id="accountHolderName"
                  name="accountHolderName"
                  placeholder="Enter Account Holder Name"
                  onChange={(e) => this.changeHandler(e)}
                  value={accountHolderName}
                  required
                />
              </div>
              <div className="mt-2">
                <input
                  type="number"
                  className="form-control bussStyle1 rounded"
                  id="accountNumber"
                  name="accountNumber"
                  placeholder="Enter Account Number"
                  onChange={(e) => this.changeHandler(e)}
                  value={accountNumber}
                  required
                />
              </div>
              <div className="mt-2">
                <input
                  type="text"
                  className="form-control bussStyle1 rounded"
                  id="ifscCode"
                  name="ifscCode"
                  placeholder="IFSC code"
                  onChange={(e) => this.changeHandler(e)}
                  value={ifscCode}
                  required
                />
              </div>
              <div className="mt-2">
                <textarea
                  name="bankAddress"
                  row="3"
                  placeholder="Enter Bank Address"
                  required
                  minLength="10"
                  maxLength="110"
                  id="bankAddress"
                  className="form-control bussStyle1 rounded"
                  onChange={(e) => this.changeHandler(e)}
                  value={bankAddress}
                ></textarea>
              </div>
              <div className="mt-2">
                <label className="qualification-label">
                  <input
                    type="file"
                    id="uploadcancellCheque"
                    multiple
                    name="uploadcancellCheque"
                    onChange={(e) => this.cancelledCheque(e)}
                    required={isChequeAvailable !== undefined ? false : true}
                  />
                  <small class="name1">
                    <i className="bi bi-download downloadIcon"></i>Choose file
                  </small>
                </label>
                {isChequeAvailable.length > 0 ? (
                  <span className="file_message">
                    {
                      isChequeAvailable.split("/")[
                      isChequeAvailable.split("/").length - 1
                      ]
                    }
                  </span>
                ) : (
                  <span className="file_message">Upload Cancelled cheque</span>
                )}
              </div>
            </div>

            {isLoading === true ? (
              <Row>
                <Col className="d-flex justify-content-center p-2 mb-3">
                  <Button
                    type="submit"
                    color="warning"
                    style={{ color: "#fff" }}
                    className="px-5"
                  >
                    <span class="spinner-border spinner-border-sm" />
                    Save & Next
                  </Button>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col className="d-flex justify-content-center p-2 mb-3">
                  <Button
                    type="submit"
                    color="warning"
                    style={{ color: "#fff" }}
                    className="px-5"
                  >
                    Save & Next
                  </Button>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </form>
    );
  }
}

export default BusinessInformation;
